import { render, staticRenderFns } from "./PurchaseProductForm.vue?vue&type=template&id=af67ea9a"
import script from "./PurchaseProductForm.vue?vue&type=script&lang=js"
export * from "./PurchaseProductForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports